// PHASE 3: What's your first milestone to achieve?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '👋',
    title: 'pages.onboarding.firstMilestone.answer1',
    subtitle: 'pages.onboarding.firstMilestone.answer1Subtitle',
  },
  {
    emoji: '🛒',
    title: 'pages.onboarding.firstMilestone.answer2',
    subtitle: 'pages.onboarding.firstMilestone.answer2Subtitle',
  },
  {
    emoji: '💬',
    title: 'pages.onboarding.firstMilestone.answer3',
    subtitle: 'pages.onboarding.firstMilestone.answer3Subtitle',
  },
  {
    emoji: '📺',
    title: 'pages.onboarding.firstMilestone.answer4',
    subtitle: 'pages.onboarding.firstMilestone.answer4Subtitle',
  },
  {
    emoji: '✍️',
    title: 'pages.onboarding.firstMilestone.answer5',
    subtitle: 'pages.onboarding.firstMilestone.answer5Subtitle',
  },
  {
    emoji: '🎯',
    title: 'pages.onboarding.firstMilestone.answer6',
    subtitle: 'pages.onboarding.firstMilestone.answer6Subtitle',
  },
]

export default function FirstMilestonePage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.firstMilestone.title"
      subtitle="pages.onboarding.firstMilestone.subtitle"
    />
  )
}
